import { put, takeEvery, call } from "redux-saga/effects";
import deleteShiftDefinition from "sc/backend/oncall/partners/shifts-definitions/remove";
import {
  REQUEST_DELETE_SHIFT_DEFINITION,
  shiftDefinitionDeleted,
  shiftDefinitionError,
} from "../../actions/shifts-definitions";

const requestDelete = function*(action) {
  try {
    yield call(deleteShiftDefinition, action.payload.id);
    yield put(shiftDefinitionDeleted(action.payload.id));
  } catch (error) {
    yield put(shiftDefinitionError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeEvery(REQUEST_DELETE_SHIFT_DEFINITION, requestDelete);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/shifts-definitions/request-delete.js